import { render, staticRenderFns } from "./CharacteristicStep3.vue?vue&type=template&id=749a484a&"
import script from "./CharacteristicStep3.vue?vue&type=script&lang=js&"
export * from "./CharacteristicStep3.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicStep3.vue?vue&type=style&index=0&id=749a484a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports